import React from 'react';
import { QueryParamProvider } from 'use-query-params';
import { AuthStoreProvider } from './AuthStore';
import { EnergyApiProvider } from './_api/EnergyApiContext';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import AuthProtected from './AuthProtected'

import Home from './Home';
import RecRegistry from './rec-registry/RecRegistry';

const queryClient = new QueryClient();

function App(): React.ReactElement {
  return (
    <AuthStoreProvider>
      <EnergyApiProvider>
        <AuthProtected>
          <Router>
            <QueryParamProvider ReactRouterRoute={Route}>
              <QueryClientProvider client={queryClient}>
                <Switch>
                  <Route path="/rec-registry">
                    <RecRegistry />
                  </Route>
                  <Route path="/">
                    <Home />
                  </Route>
                </Switch>
              </QueryClientProvider>
            </QueryParamProvider>
          </Router>
        </AuthProtected>
      </EnergyApiProvider>
    </AuthStoreProvider>
  );
}

export default App;
